var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from "react";
import { useHistory } from "react-router-dom";
import { Pane, Button, Row, Col, PaneFooter, ErrorModal, } from "@folio/stripes/components";
import { useQuery } from "react-query";
import { FormattedMessage, useIntl } from "react-intl";
import { useOkapiKy } from "@folio/stripes/core";
import { useForm, Controller } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { RecekSelect, RecekTextField } from "../../components/inputs";
import { createAgencyPrefix } from "../../api/agencyPrefixesService";
import { navigation } from "../../components/navigation";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { createAgencyPrefixSchema } from "../../utils/validationUtils";
import { useModal } from "../../utils/useModal";
import { getErrorCode } from "../../utils/getErrorCode";
import { fetchAllInternationalPrefixes } from "../../api/internationalPrefixesService";
import { getAgencyMessageId } from "../../utils/getAgencyMessageId";
function AgencyPrefixesCreate() {
    var _this = this;
    var history = useHistory();
    var ky = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var _a = useForm({
        resolver: zodResolver(createAgencyPrefixSchema(formatMessage)),
        defaultValues: {
            internationalPrefix: {},
            value: "",
        },
        mode: "onBlur",
    }), handleSubmit = _a.handleSubmit, control = _a.control, errors = _a.formState.errors;
    var _b = useModal(), isOpen = _b.isOpen, message = _b.message, openModal = _b.openModal, closeModal = _b.closeModal;
    var internationalPrefixesData = useQuery("internationalPrefixes", function () { return fetchAllInternationalPrefixes(ky); }, {
        staleTime: 3000,
    }).data;
    var getInternationalPrefixById = function (id) {
        var _a;
        return (((_a = internationalPrefixesData === null || internationalPrefixesData === void 0 ? void 0 : internationalPrefixesData.items) === null || _a === void 0 ? void 0 : _a.find(function (prefix) { return prefix.id === id; })) ||
            null);
    };
    var onSubmit = function (data) { return __awaiter(_this, void 0, void 0, function () {
        var error_1, errorCode;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 4]);
                    return [4 /*yield*/, createAgencyPrefix(ky, data)];
                case 1:
                    _a.sent();
                    history.push(navigation.agencyPrefixes.path);
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _a.sent();
                    return [4 /*yield*/, getErrorCode(error_1)];
                case 3:
                    errorCode = _a.sent();
                    openModal(formatMessage({ id: getAgencyMessageId(errorCode) }));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: formatMessage({
                id: "ui-br-agency.agency-prefix.create.pane.title",
            }), footer: React.createElement(PaneFooter, { renderStart: React.createElement(Button, { type: "submit", buttonStyle: "primary", marginBottom0: true, onClick: handleSubmit(onSubmit) },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.save" })), renderEnd: React.createElement(Button, { buttonStyle: "default", onClick: function () { return history.push(navigation.agencyPrefixes.path); }, marginBottom0: true },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.cancel" })) }) },
            React.createElement(ErrorModal, { open: isOpen, label: "Chyba", content: message, onClose: closeModal }),
            React.createElement("form", { noValidate: true, onSubmit: handleSubmit(onSubmit) },
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12, md: 6 },
                        React.createElement(Controller, { name: "internationalPrefix", control: control, render: function (_a) {
                                var field = _a.field;
                                return (React.createElement(RecekSelect, __assign({ labelId: "ui-br-agency.agency-prefix.field.label.internationalPrefix" }, field, { value: field.value ? field.value.id : "", onChange: function (e) {
                                        var selected = getInternationalPrefixById(e.target.value);
                                        field.onChange(selected);
                                    }, required: true }),
                                    React.createElement("option", { value: "" }, " "),
                                    ((internationalPrefixesData === null || internationalPrefixesData === void 0 ? void 0 : internationalPrefixesData.items) || [])
                                        .filter(function (option) { return option != null; })
                                        .map(function (option) { return (React.createElement("option", { key: option.id, value: option.id },
                                        option.agency ? option.agency.toString() : "N/A",
                                        " ",
                                        option.value)); })));
                            } }))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12, md: 6 },
                        React.createElement(Controller, { control: control, name: "value", render: function (_a) {
                                var _b;
                                var field = _a.field;
                                return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.agency-prefix.value.field.label", required: true, error: (_b = errors.value) === null || _b === void 0 ? void 0 : _b.message })));
                            } })))))));
}
export default AgencyPrefixesCreate;
